/* @ngInject */
function StackedProgressBarController ($scope, $translate) {
  $scope.stacksInfo = []

  const api = {
    _handleStacks
  }
  this.getApi = () => api

  $scope.$watchCollection('stacks', () => {
    api._handleStacks()
  })

  function _handleStacks () {
    $scope.stacksInfo = []

    $scope.stacks.forEach(stack => {
      const stackPercentage = (stack.count * 100) / $scope.total
      const stackTitle = $translate.instant('progressBarStackTitle', {
        count: stack.count,
        total: $scope.total,
        name: stack.name
      })

      $scope.stacksInfo.push({
        ...stack,
        stackTitle,
        percentage: `${stackPercentage}%`
      })
    })
  }
}

export { StackedProgressBarController }
